<div class="mx-auto">
  @if (isLogged) {
    @if (isLogin) {
      <app-login-form></app-login-form>
    } @else if (isSignup) {
      <app-signup-form></app-signup-form>
    } @else if (isForgotPassword) {
      <app-forgot-password-form></app-forgot-password-form>
    } @else if (isResetPassword) {
      <app-reset-password-form></app-reset-password-form>
    }
  } @else {
    <div class="mx-auto">
      <h2 class="h2 mb-2">Utente già loggato</h2>
      <button class="form-btn" (click)="logout()">Logout</button>
    </div>
  }
</div>
